import { render, staticRenderFns } from "./EdgeRenderer.vue?vue&type=template&id=365c5a8e&"
import script from "./EdgeRenderer.vue?vue&type=script&lang=ts&"
export * from "./EdgeRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports